import InsightsRteContent from './insightsRteContent'
export default InsightsRteContent
